export default "__VITE_ASSET__CSzp3GQX__"